import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Generic themed status/error page used by the 401/403/404/500 routes. Reuses
 * the global theme tokens (Bootstrap card + utilities); no hard-coded colors.
 */
export default function StatusPage({ code, title, message, icon = 'fa fa-triangle-exclamation' }) {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card text-center border-0">
            <div className="card-body p-5">
              <i className={`${icon} fa-3x text-secondary mb-3`} aria-hidden="true" />
              <h1 className="display-4 fw-bold text-primary mb-1">{code}</h1>
              <h2 className="h4 mb-3">{title}</h2>
              <p className="text-muted mb-4">{message}</p>
              <div className="d-flex gap-2 justify-content-center">
                <Link to="/" className="btn btn-primary">
                  <i className="fa fa-home me-2" aria-hidden="true" />
                  Go home
                </Link>
                <Link to="/login" className="btn btn-outline-secondary">
                  Sign in
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
